// Module
var code = `<form-section form-title="\$ctrl.incomeFormTitle">
  <form-section-field field-title="'Income source'" ng-if="\$ctrl.propertyConfigService.visible('customer', 'income', 'source')">
    <select type="text"
            ng-model="\$ctrl.sourceOfIncome.type"
            ng-disabled="true"
            ng-options="entry.code as entry.description for entry in \$ctrl.types">
      <option></option>
    </select>
  </form-section-field>
  <form-section-field field-title="'Primary'" ng-if="\$ctrl.propertyConfigService.visible('customer', 'income', 'primary')">
    <select ng-model="\$ctrl.sourceOfIncome.primary"
            ng-class="{'non-valid-primary-income-source': !\$ctrl.hasOnePrimaryIncomeSource()}"
            ng-disabled="!\$ctrl.editMode"
            ng-change="\$ctrl.primaryIncomeSourceChanged(\$ctrl.sourceOfIncome, \$index)"
            boolean-options>
    </select>
  </form-section-field>
  <form-section-field field-title="'Monthly income amount (Estimate)'">
    <cash ng-model="\$ctrl.monthlyIncome"
          ng-disabled="!\$ctrl.editMode""></cash>
  </form-section-field>
  <form-section-field field-title="'Annual income amount (Estimate)'">
    <cash ng-model="\$ctrl.sourceOfIncome.annualIncome"
          ng-disabled="!\$ctrl.editMode""></cash>
  </form-section-field>
  <form-section-field field-title="'SSS number'">
    <input required
           ng-model="\$ctrl.sourceOfIncome.sssNumber"
           ng-disabled="!\$ctrl.editMode"
           type="text"
           required
           ui-mask="99-9999999-9">
  </form-section-field>
  <form-section-field ng-if="\$ctrl.accounts && \$ctrl.accounts.length > 0"
                      field-title="'Product Number'">
    <account-select field-mapping="{accountGroup: null, accountGroupMaxLength: null, name: 'productNumber'}"
                    value-field="'id'"
                    label-field="'productNumber'"
                    options="\$ctrl.accounts"
                    ng-model="\$ctrl.selectedAccount"
                    ng-change="\$ctrl.updateSssPensionTargetAccountId()"
                    ng-disabled="!\$ctrl.editMode">
    </account-select>
  </form-section-field>
</form-section>

<div ng-show="\$ctrl.editMode">
  <button ng-click="\$ctrl.removeIncomeSource(\$ctrl.sourceOfIncome)"
          class="btn btn-danger btn--align-with-form-field" type="button">
    Remove source of income
  </button>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/shared/customer-profile-commons/income-source/sss-income-source.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;